import { getDateString } from 'js/lib/DateUtils';
import { DateRange, SeverityEnum } from '../types';
import { SORT_ORDER, SortOrder } from '../constants';

type BuildLogsFileNameParams = {
  flowNodeId: number;
  isTimeWindowMode: boolean;
  selectedRunId: string | null;
  dateRange: DateRange;
  severities: string[];
  viewSortOrder: SortOrder;
};

/**
 * @example
 * flow-42-run-1721937600000-logs-warning-error-oldest.txt
 */
export const buildLogsFileName = ({
  flowNodeId,
  isTimeWindowMode,
  selectedRunId,
  dateRange,
  severities,
  viewSortOrder,
}: BuildLogsFileNameParams): string => {
  const scopeSegment = isTimeWindowMode
    ? `${getDateString(dateRange.from, 'YYYY-MM-DD')}_to_${getDateString(dateRange.to, 'YYYY-MM-DD')}`
    : `run-${selectedRunId}`;

  const allSeverities = Object.values(SeverityEnum);
  const activeSeverities = allSeverities.filter((severity) => severities.includes(severity));
  const isSeverityFiltered =
    activeSeverities.length > 0 && activeSeverities.length < allSeverities.length;
  const severitySuffix = isSeverityFiltered ? `-${activeSeverities.join('-').toLowerCase()}` : '';

  const sortSuffix = viewSortOrder === SORT_ORDER.OLDEST ? '-oldest' : '';

  return `flow-${flowNodeId}-${scopeSegment}-logs${severitySuffix}${sortSuffix}.txt`;
};
